import styled from 'styled-components';
import { GREY2, BLACK } from '@swegon-core/uic/dist/src/theme';

export interface ButtonContainerProps {
    $disabled?: boolean;
}

export const ContactAndCustomizeContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    justify-items: center;
    column-gap: 16px;
    margin: 16px 16px 32px 16px;
`;

export const ButtonContainer = styled.div<ButtonContainerProps>`
    display: block;
    width: 170px;
    height: 70px;
    padding: 12px;
    text-align: center;
    align-content: flex-start;
    cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
    color: ${({ $disabled }) => ($disabled ? GREY2 : BLACK)};
`;

export const LinkButtonContainer = styled(ButtonContainer).attrs({ as: 'a' })`
    text-decoration: none;
`;

export const ButtonText = styled.span`
    margin-top: 8px;
    display: inline-block;
`;

export const IconWrapper = styled.div`
    width: 100%;
    height: 24px;
`;
